import CardCategory3 from "@/components/CardCategory3/CardCategory3";
import CardCategory4 from "@/components/CardCategory4/CardCategory4";
import CardCategory5 from "@/components/CardCategory5/CardCategory5";
import Heading from "@/components/Heading/Heading";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { useAppContext } from "@/context/AppContext";
import useNcId from "@/hooks/useNcId";
import Loader from "@/shared/FullScreenLoader/Loading";
import { FC } from "react";

export interface SectionSliderNewCategoriesProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  subHeading?: string;
  categoryCardType?: "card3" | "card4" | "card5";
  sliderStyle?: "style1" | "style2";
  itemPerRow?: number;
  uniqueClassName: string;
}

const SectionSliderNewCategories: FC<SectionSliderNewCategoriesProps> = ({
  heading = "Locations",
  subHeading = "",
  className = "",
  categoryCardType = "card3",
  sliderStyle = "style1",
  uniqueClassName,
}) => {
  
  const {cities,loading} = useAppContext()

  const UNIQUE_CLASS =
    "SectionSliderNewCategories__" + uniqueClassName + useNcId();

  const renderCard = (item:{city?:string,_count?:{city:number} }) => {
    switch (categoryCardType) {
    case "card3":
      return <CardCategory3 taxonomy={item} />;
    case "card4":
      return <CardCategory4 taxonomy={item} />;
    case "card5":
      return <CardCategory5 taxonomy={item} />;
    default:
      return <CardCategory3 taxonomy={item} />;
    }
  };

  if(!cities.length){
    return <></>
  }

  const filteredCities = cities.filter((item) => item.city!='All')

  return (
    <div className={`nc-SectionSliderNewCategories ${className}`}>
      <div className={`${UNIQUE_CLASS} flow-root`}>
        <Heading
          desc={subHeading}
          // hasNextPrev={sliderStyle === "style1"}
          isCenter={sliderStyle === "style2"}
        >
          {heading}
        </Heading>
        <div className="px-8">
          {loading && <div className="min-h-52 relative"><Loader /></div>}
          {!!filteredCities.length && <Carousel
            opts={{
              align: "start",
            }}
            className="w-full"
          >
            <CarouselContent>
              {filteredCities
                .map((item, index) => (
                  <CarouselItem key={index} className={"md:basis-1/2 lg:basis-1/5"}>
                    <div className="p-1">
                      {renderCard(item)}
                    </div>
                  </CarouselItem>
                ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>}
        </div>
       
      </div>
    </div>
  );
};

export default SectionSliderNewCategories;
